import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=a8ebc1be&scoped=true"
import script from "./Contents.vue?vue&type=script&lang=js"
export * from "./Contents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ebc1be",
  null
  
)

export default component.exports